<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol
          id="CreateLimitLocationMaxCapForm"
          col="12"
          xl="7"
          class="text-center"
        >
          <h1 class="mb-4">
            Limit Location Max Cap
            <HelpCenterButton
              classes="me-2"
              content-key="limit_location_map_cap"
            />
          </h1>
          <CreateLimitLocationMaxCapForm
            ref="CreateLimitLocationMaxCapForm"
            :is-in-view="true"
            :active-room="editableRoomCapacityLimit"
            @location-limit-created="resetDataTable()"
            @updated-limit-location-max-cap="resetDataTable()"
          />
          <LocationsMaxCapLimitTable
            ref="LocationsMaxCapLimitTable"
            :active-room="editableRoomCapacityLimit"
            @room-limit-deleted="refreshRoomsSelect()"
          />
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import CreateLimitLocationMaxCapForm from "@/components/Forms/CreateLimitLocationMaxCapForm"
import LocationsMaxCapLimitTable from "@/components/DataTables/LocationsMaxCapLimitTable"
import { mapGetters } from "vuex"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "LimitLocationMaxCap",
  components: {
    CreateLimitLocationMaxCapForm,

    LocationsMaxCapLimitTable,

    HelpCenterButton
  },
  computed: {
    ...mapGetters({
      editableRoomCapacityLimit: "rooms/editableRoomCapacityLimit"
    })
  },
  methods: {
    resetDataTable() {
      this.$refs.LocationsMaxCapLimitTable.resetDataTable(1)
    },
    refreshRoomsSelect() {
      setTimeout(() => {
        this.$refs.CreateLimitLocationMaxCapForm.refreshRoomsSelect()
      }, 500)
    }
  }
}
</script>
